import { define } from 'wicked-elements'

define('[data-component~="contrast"]', {
  init () {
    this.$button = this.element.querySelector('button')
    this.handleClick = this.handleClick.bind(this)
    this.checked = JSON.parse(localStorage.getItem('japan-story-high-contrast'))
    this.render()
  },
  connected () {
    this.element.addEventListener('click', this.handleClick, true)
  },
  disconnected () {
    this.element.removeEventListener('click', this.handleClick, true)
  },
  handleClick () {
    this.checked = !this.checked
    localStorage.setItem('japan-story-high-contrast', this.checked)
    this.render()
  },
  render () {
    this.$button.setAttribute('aria-checked', this.checked)
    if (this.checked) {
      document.documentElement.classList.add('high-contrast')
    } else {
      document.documentElement.classList.remove('high-contrast')
    }
  }
})